import { render } from "./AppLayoutMenu.vue?vue&type=template&id=0ba14872&scoped=true"
import script from "./AppLayoutMenu.vue?vue&type=script&lang=js"
export * from "./AppLayoutMenu.vue?vue&type=script&lang=js"

import "./AppLayoutMenu.vue?vue&type=style&index=0&id=0ba14872&lang=scss&scoped=true"
import "./AppLayoutMenu.vue?vue&type=style&index=1&id=0ba14872&lang=css"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba14872"]])

export default __exports__